function createMountHook(useHook) {
  return function (effect) {
    useHook(function () {
      effect();
    }, []);
  };
}
export default createMountHook;